// Cookie lifetime follows the server-issued JWT. This only reads expiry;
// authentication and signature validation remain the backend's responsibility.
export function sessionCookieExpiry(token: string): Date {
  const payload = JSON.parse(
    atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')),
  ) as { exp?: number }
  if (typeof payload.exp !== 'number' || !Number.isFinite(payload.exp)) {
    throw new Error('Missing session expiry')
  }
  const expires = new Date(payload.exp * 1000)
  if (Number.isNaN(expires.getTime())) throw new Error('Invalid session expiry')
  return expires
}

export function refreshedSessionCookie(token: string, secure: boolean): string {
  return `authToken=${encodeURIComponent(token)}; Path=/; SameSite=Lax; Expires=${sessionCookieExpiry(token).toUTCString()}${secure ? '; Secure' : ''}`
}
